import { Fragment, VFC } from 'react';

import { DynamicFilterSet } from 'dashboard/models/metrics-verification';
import BaseVerificationFilterRow, {
  FilterRule,
} from 'dashboard/views/DashboardVerificationAnalyticsVolumeView/BaseVerificationFilterRow';
import {
  FilterDimensions,
  FilteredVerificationType,
} from 'dashboard/views/DashboardVerificationAnalyticsVolumeView/VerificationFilteredMetrics';
import Spacer from 'design-system/components/Spacer';

interface AndRulesSectionProps {
  andRules: Array<FilterRule>;
  orIndex: number;
  deleteAndRule: (
    type: FilteredVerificationType,
    orRuleIndex: number,
    andRuleIndex: number,
  ) => void;
  updateAndRule: (
    type: FilteredVerificationType,
    orRuleIndex: number,
    andRuleIndex: number,
    dimension?: FilterDimensions,
    operator?: string,
    values?: string[],
  ) => void;
  verificationType: FilteredVerificationType;
  handleOpenDropdown: () => void;
  handleCloseDropdown: () => void;
  typeDynamicOptions?: DynamicFilterSet;
}

const AndRulesSection: VFC<AndRulesSectionProps> = ({
  andRules,
  orIndex,
  deleteAndRule,
  updateAndRule,
  verificationType,
  handleOpenDropdown,
  handleCloseDropdown,
  typeDynamicOptions,
}) => {
  return (
    <>
      {andRules.map((andRule, andIndex) => (
        <Fragment key={`orRule-${orIndex}-andRule-${andIndex}`}>
          <BaseVerificationFilterRow
            andRule={andRule}
            orIndex={orIndex}
            andIndex={andIndex}
            deleteAndRule={deleteAndRule}
            updateAndRule={updateAndRule}
            verificationType={verificationType}
            handleOpenDropdown={handleOpenDropdown}
            handleCloseDropdown={handleCloseDropdown}
            typeDynamicOptions={typeDynamicOptions}
          />
          <Spacer height={2} />
        </Fragment>
      ))}
    </>
  );
};

export default AndRulesSection;
